import * as navigation from 'Navigation';

import RequestV2SubmissionFileState from './RequestV2SubmissionFileState';

export default class RequestV2SubmissionDocumentTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Request',
      closeable: false,
      preferenceKey: navigation.PREFERENCE_KEY_IGNORE,
    };
  }

  getRequestV2SubmissionFileState(): RequestV2SubmissionFileState {
    return this.get('requestV2SubmissionFileState');
  }
}
